import React, { useEffect } from 'react'
import styles from './Datepicker.module.css'
import './datepicker-custom.css'
import DatePicker, { registerLocale } from "react-datepicker";
import th from "date-fns/locale/th"; 
import { format, subYears } from "date-fns";
import { FaCalendarAlt, FaTimes } from "react-icons/fa"; 

registerLocale("th", th);

// หมายเหตุ: value ควรเป็น [startDate, endDate]
function DateRangePicker({disabled, label, value, setValue, className, title}) {
    
    // แยก startDate และ endDate ออกจาก array value
    const [startDate, endDate] = value || [null, null];

    const convertToThaiFormat = (date) => { 
        if (!date) return "";
        const thaiYear = date.getFullYear() + 543;
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        return `${day}/${month}/${thaiYear}`;
    };

    const clearCalendar = (e) => {
        e.stopPropagation(); // กันไม่ให้ calendar เด้งเปิดตอนกดลบ
        setValue([null, null]);
    };

    const CustomInput = React.forwardRef(({ value, onClick, disabled }, ref) => {
        // สร้างข้อความแสดงผล เช่น "01/01/2567 - 05/01/2567"
        const displayValue = startDate 
            ? `${convertToThaiFormat(startDate)}${endDate ? ` - ${convertToThaiFormat(endDate)}` : ""}`
            : "";

        return (
            <div
                className="flex border-[1px] border-[#eee] rounded-[5px] items-center px-2"
                style={{
                    height: "40px",
                    border: "1px solid #A2B5BC",
                    backgroundColor: disabled ? "#f7f7f7" : "#ffffff",
                    cursor: disabled ? "not-allowed" : "pointer",
                }}
                onClick={onClick}
            >
                <FaCalendarAlt color="#747081" className="mr-2" />
                <input
                    type="text"
                    className="w-full outline-none bg-transparent cursor-pointer"
                    ref={ref}
                    value={displayValue}
                    placeholder="เลือกช่วงวันที่"
                    readOnly
                    disabled={disabled}
                />
                {!disabled && startDate && (
                    <FaTimes
                        className="ml-2 cursor-pointer hover:text-red-500"
                        onClick={clearCalendar}
                    />
                )}
            </div>
        );
    });

    const handleChange = (update) => {
        // update จะเป็น [newStartDate, newEndDate] อัตโนมัติจากโหมด selectsRange
        setValue(update);
    };

    return (
      <div className='flex flex-col'>
        <div className={title === "publicity" ? `${className}` : `${styles.label}`}>
          {label}
        </div>
        <DatePicker
          selectsRange={true} // เปิดโหมดช่วงวันที่
          startDate={startDate}
          endDate={endDate}
          onChange={handleChange}
          disabled={disabled}
          locale="th"
          isClearable={false} // เราทำปุ่มลบเองใน CustomInput แล้ว
          dropdownMode="select"
          customInput={<CustomInput />}
          shouldCloseOnSelect={false} // เพื่อให้เลือกวันจบได้ก่อนค่อยปิด
          renderCustomHeader={({
            date,
            changeYear,
            changeMonth,
            decreaseMonth,
            increaseMonth,
            prevMonthButtonDisabled,
            nextMonthButtonDisabled,
          }) => {
            const year = date.getFullYear();
            const month = date.getMonth();

            return (
              <div className="flex justify-around items-center px-2 py-1">
                <button type="button" onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>{"<"}</button>
                <select
                  value={month}
                  onChange={(e) => changeMonth(Number(e.target.value))}
                  className="mx-1 border rounded"
                >
                  {Array.from({ length: 12 }).map((_, i) => (
                    <option key={i} value={i}>
                      {format(new Date(2000, i, 1), "MMMM", { locale: th })}
                    </option>
                  ))}
                </select>
                <select
                  value={year}
                  onChange={(e) => changeYear(Number(e.target.value))}
                  className="mx-1 border rounded"
                >
                  {/* แสดงปีย้อนหลัง 10 ปี และไปข้างหน้า 10 ปี หรือปรับตามต้องการ */}
                  {Array.from({ length: 100 }).map((_, i) => {
                    const y = (new Date().getFullYear() + 10) - i;
                    return (
                      <option key={y} value={y}>
                        {y + 543}
                      </option>
                    );
                  })}
                </select>
                <button type="button" onClick={increaseMonth} disabled={nextMonthButtonDisabled}>{">"}</button>
              </div>
            );
          }}
        />
      </div>
    );
}

export default DateRangePicker;